import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { Store } from "@ngrx/store";
import { NavController } from "ionic-angular";
import { Subscription } from "rxjs";
import { Observable } from "rxjs/Observable";
import { PurchasesData } from "../../providers/purchases";
import { Utilities } from "../../providers/utilities";

@Component({
  selector: "purchases-product",
  templateUrl: "purchases-product.html",
})
export class PurchasesProductComponent implements OnInit, OnDestroy {

  @Input() public isPage: boolean = false;

  public openDetail: number;
  public clientId: string;
  public limitTo: number = 10;
  public products$: Observable<{}>;
  public purchasesTmp$: Observable<{}>;
  private clientSubscribe: Subscription;

  constructor(
    public navCtrl: NavController,
    private store: Store<{}>,
    private purchaseData: PurchasesData,
    private utilities: Utilities,
  ) { }

  // tslint:disable-next-line:no-empty
  public ngOnInit() {}
  // ngOnInit() {
  //   this.clientSubscribe = this.store.select(sharedSelectors.getClientId).subscribe(clientId => {
  //     if (clientId) {
  //       this.clientId = clientId;
  //       this.purchasesTmp$ = this.purchaseData.getAllByClient(clientId)
  //         .map(list => list.reduce((total, next, index) => {
  //             return { ...total, ...next };
  //           }, {})
  //         )
  //         .map(list => Object.keys(list).map(i => list[i]))
  //         .map(list => list.sort((a, b) => {
  //           a = new Date(a.transaction.payment_date);
  //           b = new Date(b.transaction.payment_date);
  //           return a > b ? -1 : a < b ? 1 : 0;
  //         }))
  //         .do(list => this.utilities.consoleDecorator('Purchases list', list));

  //       this.purchases$ = this.purchasesTmp$;
  //     }
  //   });
  // }

  // search(ev) {
  //   this.purchases$ = this.purchasesTmp$.map((items: any) => items.filter((item) => this.utilities.searchItem(
  //     ev.target.value,
  //     item,
  //     [{ 'transaction': ['id', 'payment_date', 'authorization_code', 'amount', 'status'] }]
  //   )));
  // }

  // loadMore(infiniteScroll, list: any[]) {
  //   if (this.limitTo < list.length) {
  //     this.limitTo += 10;
  //     setTimeout(() => {
  //       infiniteScroll.complete();
  //     }, 300);
  //   } else {
  //     infiniteScroll.enable(false);
  //   }
  // }

  // public isOpen(key) {
  //   return this.openDetail === key;
  // }

  // public open(key) {
  //   if (this.openDetail === key) {
  //     this.openDetail = null;
  //   } else {
  //     this.openDetail = key;
  //   }
  // }

  // download() {
  //   this.purchaseData.getAllByClient
  // }

  public ngOnDestroy() {
    if (this.clientSubscribe) { this.clientSubscribe.unsubscribe(); }
  }
}



// WEBPACK FOOTER //
// ./src/components/purchases-product/purchases-product.ts